import React from 'react';
import { FormattedMessage } from 'react-intl';
import { UserCard, Modal } from '../../components';

import css from './ListingPage.css';

const SectionHostMaybe = props => {
  const {
    title,
    listing,
    userData,
    authorDisplayName,
    onContactUser,
    isEnquiryModalOpen,
    onCloseEnquiryModal,
    sendEnquiryError,
    sendEnquiryInProgress,
    onSubmitEnquiry,
    currentUser,
    onManageDisableScrolling,
  } = props;

  if (!userData) {
    return null;
  }
  console.log(userData)

  return (
    <div>
       <UserCard userDetails={userData}></UserCard>
    </div>
  )

  return (
    <div id="host" className={css.sectionHost}>
      <h2 className={css.sideTitle}>
        <FormattedMessage id="ListingPage.yourHostHeading" />
        <p className={css.sideSubTitle}>
          <FormattedMessage id="ListingPage.yourHostSubHeading" />
        </p>
      </h2>
      <UserCard user={listing.author} currentUser={currentUser} onContactUser={onContactUser} />
    </div>
  );
};

export default SectionHostMaybe;
